import React from 'react';

import {Helmet, useParams, useBasePath, useNavigate} from 'views/module';

import UserListScene from 'views/scenes/admin/user/list/UserList';
import NewUser from 'views/scenes/admin/user/new/NewUser';
import DeactivateUser from 'views/scenes/admin/user/deactivate/DeactivateUser';

const UserList = (props) => {
  const [model, setModel] = React.useState('');
  const [userRn, setUserRn] = React.useState();
  const [reload, setReload] = React.useState(0);

  const basePath = useBasePath();
  const params = useParams();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (basePath === '/admin/user/new') {
      setModel('CREATE');
    } else if (basePath === '/admin/user/:userRn/deactivate') {
      setUserRn(params.userRn);
      setModel('DEACTIVATE');
    } else {
      setModel('VIEW');
    }
  }, [basePath, params]);

  const popModelGenerator = React.useCallback(() => {
    const closeModel = (reload) => {
      navigate(`/admin/user`);
      if (reload) {
        setReload((e) => e + 1);
      }
    };
    let popModel = null;
    switch (model) {
      case 'CREATE':
        popModel = <NewUser
          closeModel={closeModel}
        />;
        break;
      case 'DEACTIVATE':
        popModel = <DeactivateUser
          userRn={userRn}
          closeModel={closeModel}
        />;
        break;
      default:
        break;
    }
    return popModel;
  }, [model, userRn]);

  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      {popModelGenerator()}
      <UserListScene
        reload={reload}
        setReload={setReload}
      />
    </>
  );
};

export default UserList;
